import { createI18nText } from '@hilma/netina2all';

const orderSummaryText = createI18nText({
	he: {
		name: 'שם',
		address: 'כתובת',
		phone: 'טלפון',
		email: 'מייל',
		station: 'תחנה',
		association: 'עמותה',
		allAssociations: 'חלוקה לכל העמותות',
		productSummary: 'סיכום מוצרים',
		amount: 'כמות',
		total: 'סה"כ',
		holders: 'נרתיקים',
		costSummary: 'סיכום עלויות',
		fourCost: 'עלות המוצרים',
		itemsCost: 'עלות המוצרים',
		fourDonation: 'תרומה מרכישת המוצרים',
		itemsDonation: 'תרומה מרכישת המוצרים',
		atoneDonation: 'תרומה ממתנות לאביונים',
		totalDonated: 'סה"כ תרומה',
		allDonated: 'הכל לתרומה',
		totalPayment: 'סה"כ לתשלום',
	},
	en: {
		name: 'Name',
		address: 'Address',
		phone: 'Phone Number',
		email: 'Email',
		station: 'Station',
		association: 'Association',
		allAssociations: 'All associations',
		productSummary: 'Product Summary',
		amount: 'Amount',
		total: 'Total',
		holders: 'Holders',
		costSummary: 'Cost Summary',
		fourCost: 'Cost of the products',
		itemsCost: 'Cost of the items',
		fourDonation: 'Donation from acquisition of the products',
		itemsDonation: 'Donation from acquisition of the items',
		atoneDonation: "Donation from Matanot L'evyonim",
		totalDonated: 'Donated in Total',
		allDonated: 'The full sum is donated to charity',
		totalPayment: 'Total',
	}
});

export default orderSummaryText;